'use strict';

import React from 'react';
import PropTypes from 'prop-types';
import { cn } from '@src/utils/ui';
import { ServiceBadge } from '../service-badge/service-badge';

export const CriminalCheckBadge = ({ className = '' }) => {
    return (
        <ServiceBadge
            className={cn(
                'tw-gap-[4px] tw-bg-primary-200 tw-flex tw-items-center tw-justify-center tw-text-primary-500 tw-rounded-[4px] tw-border-primary-500 tw-border-[0.5px]',
                className
            )}
        >
            <span className='tw-text-[12px] tw-font-[700]'>Criminal Record Check Cleared</span>
        </ServiceBadge>
    );
};

CriminalCheckBadge.propTypes = {
    className: PropTypes.string
};
